import { NoResults } from "../../../components/NoResults/NoResults.js";
import { useShiftGeoLocationHistory } from "../../Users/hooks/useShiftGeoLocationHistory.js";
import React, { Suspense } from "react";
import { Loading, Modal } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Scheduling/shared/ShiftGpsReviewModal.tsx
var ShiftGpsReviewMap = React.lazy(() => import("./ShiftGpsReviewMap.js").then((m) => ({ default: m.ShiftGpsReviewMap })));
function ShiftGpsReviewModal({ driftMeters, fromDate, isOpen, onClose, perimeter, toDate, userId }) {
	const { data: breadcrumbs, loading } = useShiftGeoLocationHistory({
		fromDate,
		toDate,
		userId
	}, { fire: isOpen });
	if (!isOpen) return null;
	return /* @__PURE__ */ jsx(Modal, {
		closeHandler: onClose,
		outsideClickClose: true,
		width: "900px",
		children: /* @__PURE__ */ jsx("div", {
			className: "flex h-[70vh] flex-col",
			children: loading ? /* @__PURE__ */ jsx("div", {
				className: "relative flex-1",
				children: /* @__PURE__ */ jsx(Loading, {
					overlay: true,
					size: "xl"
				})
			}) : !breadcrumbs || !breadcrumbs.length ? /* @__PURE__ */ jsx(NoResults, { text: "No GPS data for this shift" }) : /* @__PURE__ */ jsx(Suspense, {
				fallback: /* @__PURE__ */ jsx("div", {
					className: "relative flex-1",
					children: /* @__PURE__ */ jsx(Loading, {
						overlay: true,
						size: "xl"
					})
				}),
				children: /* @__PURE__ */ jsx(ShiftGpsReviewMap, {
					breadcrumbs,
					driftMeters,
					fromDate,
					perimeter,
					toDate
				})
			})
		})
	});
}
//#endregion
export { ShiftGpsReviewModal };

//# sourceMappingURL=ShiftGpsReviewModal.js.map